import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useApp } from '../context/AppContext';

export default function CommentsPanel({ momentId, onCountChange }) {
  const { user, socket } = useApp();
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    axios.get(`https://songmoment.onrender.com/api/comments/${momentId}`).then(res => {
      setComments(res.data);
      setLoading(false);
    });

    if (socket) {
      socket.emit('join_moment', momentId);
      socket.on('new_comment', (comment) => {
        if (comment.moment_id === momentId) {
          setComments(prev => [...prev, comment]);
        }
      });
      socket.on('delete_comment', (id) => {
        setComments(prev => prev.filter(c => c.id !== id));
      });
      return () => {
        socket.emit('leave_moment', momentId);
        socket.off('new_comment');
        socket.off('delete_comment');
      };
    }
  }, [momentId, socket]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [comments]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim() || !user) return;
    try {
     await axios.post('https://songmoment.onrender.com/api/comments', { moment_id: momentId, user_id: user.id, text });
      setText('');
      onCountChange(1);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="slide-in" style={{ marginTop: 10 }}>
      {/* Comments list */}
      <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 8 }}>
        {loading ? (
          <p style={{ fontSize: 12, color: 'var(--text3)', padding: '4px 0' }}>Loading...</p>
        ) : comments.length === 0 ? (
          <p style={{ fontSize: 12, color: 'var(--text3)', padding: '4px 0' }}>No comments yet — be first!</p>
        ) : (
          comments.map(c => (
            <div key={c.id} className="slide-in" style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'flex-start' }}>
              <div style={{
                width: 24, height: 24, borderRadius: '50%', flexShrink: 0,
                background: `hsl(${c.username?.charCodeAt(0) * 15 || 200}, 60%, 40%)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, fontWeight: 700, color: '#fff',
              }}>
                {c.username?.[0]?.toUpperCase()}
              </div>
              <div style={{ background: 'var(--bg3)', borderRadius: 8, padding: '6px 10px', flex: 1 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--accent2)', marginRight: 6 }}>@{c.username}</span>
                <span style={{ fontSize: 13, color: 'var(--text)' }}>{c.text}</span>
              </div>
            </div>
          ))
        )}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      {user ? (
        <form onSubmit={submit} style={{ display: 'flex', gap: 8 }}>
          <input
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="What do you think of this moment?"
            style={{
              flex: 1, background: 'var(--bg3)', border: '1px solid var(--border)',
              borderRadius: 8, padding: '7px 12px', fontSize: 13, color: 'var(--text)',
              transition: 'border-color 0.2s',
            }}
            onFocus={e => e.target.style.borderColor = 'var(--accent)'}
            onBlur={e => e.target.style.borderColor = 'var(--border)'}
          />
          <button type="submit" disabled={!text.trim()} style={{
            background: 'var(--accent)', color: '#fff', borderRadius: 8,
            padding: '7px 14px', fontSize: 13, fontWeight: 500,
            opacity: text.trim() ? 1 : 0.4, transition: 'opacity 0.2s',
          }}>
            Post
          </button>
        </form>
      ) : (
        <p style={{ fontSize: 12, color: 'var(--text3)' }}>Sign in to comment</p>
      )}
    </div>
  );
}
